<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4D24/4D24.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4D24 2.4T Diesel Engine</div>
        <div class="detail-banner-desc">
          All-New 2.4L Turbo High-Performance Low-Fuel-Consumption Diesel Engine (Electronically Controlled Silicone Fan or Electronic Fan Configurations Available).
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">Powerful Performance</div>
    <div class="detail-desc">Low initial speed for maximum torque with a broad effective range ensures smooth acceleration and ample power, enhancing driving refinement.</div>
    <div class="detail-utils">
      <div class="detail-utils-item">
        <div class="detail-utils-d">Maximum power</div>
        <div class="detail-utils-u">137kW 3600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">Maximum torque</div>
        <div class="detail-utils-u">490N·m 1500~2500r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">Low-speed torque</div>
        <div class="detail-utils-u">1000r/min 260N·m，1200r/min 350N·m</div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D24/4D24-1.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            Efficient Electronically Controlled VGT Turbocharger
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              20%
            </div>
            <div class="detail-swiper-d">
              increase in volumetric efficiency
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              30%
            </div>
            <div class="detail-swiper-d">
              improvement in low-speed power output
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              260N·m
            </div>
            <div class="detail-swiper-d">
              torque（1000r/min）
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">Low Fuel Consumption</div>
    <div class="detail-desc">Newly designed cylindrical combustion chamber and high-efficiency dual-tangential intake ports, paired with a 2000bar high-pressure common rail system. Strategic application of high- and low-pressure EGR, along with multiple friction-reduction measures, ensures more complete combustion and lower fuel consumption.</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-2.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          Optimized intake system
        </div>
        <div class="detail-four-desc">
          Dual-tangential ports improve airflow, increasing swirl ratio by 63% for enhanced fuel economy prominently.
        </div>
        <div class="detail-four-units">
          <div class="detail-four-unit-item">
            <div class="detail-four-u">
              63
              <span>
                %
              </span>
            </div>
            <div class="detail-four-d">
              swirl ratio improvement
            </div>
          </div>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          High-pressure common rail system
        </div>
        <div class="detail-four-desc">
          2000bar pressure combined with high-speed electromagnetic fuel injectors improves combustion efficiency.
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-3.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box detail-bottom-bgs">

    <div class="detail-updown-list">
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          Variable displacement oil pump
        </div>
        <div class="detail-updown-desc">
          On-demand oil pressure regulation reduces fuel consumption by 0.8%.
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-4.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          High- and low-pressure EGR
        </div>
        <div class="detail-updown-desc">
          Combined with close-coupled after-treatment, lowers vehicle fuel consumption by 2%.
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-5.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box">
    <div class="detail-title">NVH</div>
    <div class="detail-desc">Aimed at delivering the most refined diesel engine sound, improvements in active and passive noise reduction achieve NVH levels comparable to gasoline engines.</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-6.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          Parallel backlash-reducing gear camshaft
        </div>
        <div class="detail-four-desc">
          Dual overhead parallel anti-backlash gear drive reduces gear vibration by 74% and cuts gear rattling noise by 4~5 dBA.
        </div>

      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          Timing system
        </div>
        <div class="detail-four-desc">
          Optimized pulley phasing reduces timing belt tension and meshing noise. The belt system operates quietly, complemented by an upper plastic/lower aluminum timing cover that effectively shields high- and low-frequency noise.
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-7.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>


  <div class="detail-box detail-bottom-bgs">

    <div class="detail-updown-list">
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          Rear Gear-Driven Balance Shaft
        </div>
        <div class="detail-updown-desc">
          Incorporates a balance shaft for enhanced NVH refinement. Driven by a gear at the crankshaft rear, it reduces torsional excitation and gear noise, lowering overall mechanical noise by 2 dBA.
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-8.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-updown-item">
        <div class="detail-updown-title">
          Fuel System & Top-End Acoustic Insulation
        </div>
        <div class="detail-updown-desc">
          He high-pressure fuel pump, rail, and injectors are enveloped in passive noise-suppression wraps. Made from self-extinguishing flame-retardant material with a conforming design and optimized density for excellent sound damping.
        </div>
        <div class="img-box">
          <img src="/assets/product/engine/4D24/4D24-9.jpg" alt=""></img>
        </div>
      </div>
    </div>
  </div>

  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4D24 2.4T Diesel Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4D24.html'

};

import { createApp } from 'vue';
import App from './4D24.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4D24.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>